import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.localStorage,
  })],
  state: {
    cart: {},
    user: {
      loggedIn: false,
      data: null,
    }
  },
  mutations: {
    ADD_TO_CART(state, payload) {
      Vue.set(state.cart, payload.id, payload);
    },
    REMOVE_FROM_CART(state, payload) {
      Vue.delete(state.cart, payload);
    },
    EMPTY_CART(state) {
      state.cart = {};
    }, 
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state,data) {
      state.user.data = data;
    }
  },
  actions: {
    addToCart({ commit }, product) {
      commit("ADD_TO_CART", product);
    },
    removeFromCart({commit}, productID) {
      commit("REMOVE_FROM_CART", productID);
    },
    emptyCart({commit}) {
      commit("EMPTY_CART")
    }, 
    setUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null); 
      if(user) {
        commit("SET_USER", {
          email: user.attributes.email,
        });
      }
    }
  },
  modules: {
  }
})
